import LogoTitle from '../../assets/images/logo-s.png';
import { Link } from 'react-router-dom';
import './index.scss';
import { useState, useEffect } from 'react';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './Logo';
import Loader from 'react-loaders';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const nameArray = ['a', 'm', 'a', 'n', 't', 'h', 'a'];
    const jobArray = ['F', 'u', 'l', 'l', '-', 'S', 't', 'a', 'c', 'k'];
    const jobArray2 = ['S', 'o', 'f', 't', 'w', 'a', 'r', 'e', ' '];
    const jobArray3 = ['E', 'n', 'g', 'i', 'n', 'e', 'e', 'r', '!']

    const [windowSize, setWindowSize] = useState(window.innerWidth);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize(window.innerWidth);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, []);
    
    useEffect(() => {
        const timer = setTimeout(()=> {
            setLetterClass('text-animate-hover')
        }, 5000);
        return () => clearTimeout(timer);
    }, [])

    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>i,</span>
                <br />
                <span className={`${letterClass} _13`}>I</span>
                <span className={`${letterClass} _14`}>'m</span>

                {windowSize < 620 ? <br /> : null}

                <img 
                    src={LogoTitle} 
                    alt="S" 
                    style={ windowSize < 620 ? {marginLeft: 0} : null}
                />

                <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={nameArray}
                    idx={15}
                />
                <br />
                <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={jobArray}
                    idx={22}
                />
                <br />
                <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={jobArray2}
                    idx={33}
                />

                {windowSize < 620 ? <br/> : null}

                <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={jobArray3}
                    idx={41}
                />
                
                </h1>
                <h2>JavaScript | React | Node.js | SQL | HTML | CSS </h2>
                <Link to="/contact" className='flat-button'>CONTACT ME</Link>
            </div>
            <Logo />
        </div>
        <Loader type="ball-clip-rotate-multiple" />
        </>
    );
}

export default Home;